import styled from 'styled-components';
import {bordersStyles} from '../../../../utils/styles';

const StyledInvoiceTabsContainer = styled.div`
  display: flex;
  justify-content: center;
  overflow-x: hidden;
  padding: 24px;
  position: relative;
  transition: .3s ease-in-out;

  .unmatched-totals {
    margin-left: 24px;
  }
`;

const StyledInvoicesTabsContent = styled.div`
  ${bordersStyles.light};
  background-color: ${props => props.theme.colors.neutral_1};
  padding: 34px 24px 24px 24px;
  position: relative;
  width: 100%;

  .ant-tabs-content-holder {
    border-bottom-right-radius: 4px;
    border-top-right-radius: 4px;
    min-height: unset;
  }
`;

export {
  StyledInvoiceTabsContainer,
  StyledInvoicesTabsContent,
}
